import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Tag, Select, Radio, Input, Button, Breadcrumb } from 'antd'
import { Queries  } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import Search from '../../../components/user/Search'
import QualityDocumentDetail from '../../../components/user/QualityDocumentDetail'
import PolicyDocumentsDetail from '../../../components/user/PolicyDocumentsDetail'

//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { changeFormatdate } from '../../../utils/formatdate'

const { Text, Title } = Typography
const InputGroup = Input.Group;

class PolicyDetail extends React.Component {

    state = {
        detailDocument: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        listSystem: [],
        selectSearch: "search",
        selectSystem: null,
        searchForm:null,
        defaultValueSearch: null,
        preload: false,
        showDetail:"search",
        detailPolicy:null,
        dataFirstPage:true,
        checkUser:false,
        subTitle: ""
    }

    fetchListKCMHDocumentDetail = async (docId) => {
        const { client, location, match } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListDocumen,
            variables: {
                docId: match.url.split('/')[3]
            }
        })

        ////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }
        console.log(data.fetchListDocument[0])
        if(data.fetchListDocument[0]){
            await this.setState({
                detailPolicy: data.fetchListDocument[0],
            })
        }else{
            await this.setState({
                detailPolicy: null,
            })
        }
       
    }

    async componentDidMount() {
        const { match, location } = this.props
        // await this.fetchProfile()
        await this.fetchListKCMHDocumentDetail()
    }  

    render() {
        const { match, location } = this.props
        const { detailDocument, listSystem, selectSearch, selectSystem, defaultValueSearch, showDetail, preload, dataFirstPage, detailPolicy, checkUser, subTitle } = this.state
        // console.log(location)
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    detailPolicy &&
                    <PolicyDocumentsDetail detailPolicy={detailPolicy}/>
                }
            </Container>
        )
    }
}

PolicyDetail.propTypes = {
    //
}

export default withApollo(PolicyDetail)